import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';
import {Handler, HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {InputDialog} from '../common/dialogs/inputDialog';

/*
 * Props.
 */

interface OpenConversationDialogProps {
  initialValue?: string;
  hasError?: boolean;
  errorMessage?: ReactNode;
  onValueSelect: HandlerOf<string>;
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const OpenConversationDialog: FC<OpenConversationDialogProps> = (props) => (
  <InputDialog
    {...props}
    title={<Trans id="open-conversation-title">Open a conversation</Trans>}
    okButtonLabel={<Trans id="open-conversation-ok">Go</Trans>}
  >
    <Trans id="open-conversation-content">Enter the link or ID of a Front conversation</Trans>
  </InputDialog>
);
